export const SET_BRAND_LIMIT_SEARCH = 'setBrandLimitSearchResults';
export const SET_BRAND_LIMIT_BUSY = 'setBrandLimitBusy';
export const SET_BRAND_LIMIT_GET = 'setBrandLimitGet';
export const SET_BRAND_LIMIT_TEXT = 'setBrandLimitText';
export const SET_BRAND_LIMIT_UPPER_LIMIT = 'setBrandLimitUpperLimit';
export const SET_BRAND_LIMIT_UNLIMITED_FLAG = 'setBrandLimitUnlimitedFlag';
export const SET_BRAND_LIMIT_ADD_OFFER = 'setBrandLimitAddOffer';
export const SET_BRAND_LIMIT_REMOVE_OFFER = 'setBrandLimitRemoveOffer';
export const SET_BRAND_LIMIT_SAVE_OFFER = 'setBrandLimitSaveOffer';



// WEBPACK FOOTER //
// ./src/store/brand-limit/mutations.type.js